import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, ImageOff, Car, Globe2, LayoutDashboard } from 'lucide-react';
const problems = [{
  icon: <Clock className="w-6 h-6 text-white" data-id="element-176" />,
  title: 'Wasted Inspections',
  description: "Hours lost visiting properties that don't match your requirements."
}, {
  icon: <ImageOff className="w-6 h-6 text-white" data-id="element-177" />,
  title: 'Misleading Photos',
  description: 'Static images often hide flaws and misrepresent actual space.'
}, {
  icon: <Car className="w-6 h-6 text-white" data-id="element-178" />,
  title: 'Traffic & Logistics',
  description: 'The stress of navigating Lagos traffic for multiple viewings.'
}, {
  icon: <Globe2 className="w-6 h-6 text-white" data-id="element-179" />,
  title: 'Diaspora Challenges',
  description: 'Expatriates struggle to verify properties remotely before relocating.'
}, {
  icon: <LayoutDashboard className="w-6 h-6 text-white" data-id="element-180" />,
  title: 'Layout Confusion',
  description: 'Difficulty understanding the true flow and scale of a property.'
}];
export function Problem() {
  return <section className="py-24 bg-zinc-950 relative" data-id="element-181">
      <div className="max-w-7xl mx-auto px-6" data-id="element-182">
        <FadeIn className="mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-display font-medium text-white mb-4" data-id="element-184">
            The traditional property search is broken.
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl" data-id="element-185">
            House-hunting in Nigeria comes with unique pain points. We built
            MUNISVerse to solve them.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-186">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} className={`glass-panel p-8 rounded-3xl ${index === 3 ? 'lg:col-span-2 lg:col-start-1' : ''} ${index === 4 ? 'lg:col-span-1' : ''}`} data-id="element-187">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6" data-id="element-188">
                {problem.icon}
              </div>
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-189">
                {problem.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-190">
                {problem.description}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}